"use client";

import Image from "next/image";
import { ButtonHTMLAttributes } from "react";
import clsx from "clsx";

interface GoogleButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  text?: string;
}

export const GoogleButton = ({
  className,
  text = "Sign Up with Google",
  ...props
}: GoogleButtonProps) => {
  return (
    <button
      className={clsx(
        "min-w-[361px] h-[50px] rounded-[34px] bg-white border border-[#C9C8C8] flex items-center gap-[16px] px-[16px]",
        className
      )}
      {...props}
    >
      <Image
        src="/images/icons/google.png"
        alt="Google"
        width={20}
        height={20}
        loading="lazy"
      />
      <span className="text-[14px] font-[600] text-center flex-1">{text}</span>
    </button>
  );
};
